import Cookies from "universal-cookie";
import { jwtDecode } from "jwt-decode";

const cookies = new Cookies();

/**
 *
 * @param {String} logStatus
 * @param {String} value
 * @return {Object}
 */
// export const isUserLogged = (logStatus, value) => {
//   const cookie = cookies.get("digi_at_nss");
//   if (logStatus === "logout") {
//     cookies.remove("digi_at_nss");
//     return { isLogged: false, cookie };
//   } else if (logStatus === "login") {
//     cookies.set("digi_at_nss", value);
//     return { isLogged: true, cookie };
//   } else {
//     if (cookie) {
//       const decoded = jwtDecode(cookie);
//       if (decoded?.jti) {
//         if (decoded?.exp * 1000 > new Date().getTime()) {
//           return { isLogged: true, cookie };
//         } else {
//           cookies.remove("digi_at_nss");
//           return { isLogged: false, cookie };
//         }
//       } else return { isLogged: false, cookie };
//     } else return { isLogged: false, cookie };
//   }
// };

export const isUserLogged = (logStatus, value) => {
  const cookie = cookies.get("zk-vg") || cookies.get("zk-vg");
  console.log("Hi", cookies);
  console.log("Hi", cookie);

  if (logStatus === "logout") {
    cookies.remove("zk-vg");
    cookies.remove("zk-vg");
    cookies.remove("zk-vg");

    return { isLogged: false, cookie };
  } else if (logStatus === "login") {
    const decoded = jwtDecode(value);
    cookies.set("zk-vg", value);
    return { isLogged: true, cookie, role: decoded?.role };
  } else {
    if (cookie) {
      const decoded = jwtDecode(cookie);
      if (decoded?.exp * 1000 > new Date().getTime()) {
        return { isLogged: true, cookie, role: decoded?.role };
      } else {
        cookies.remove("zk-vg");
        cookies.remove("zk-vg");
        cookies.remove("zk-vg");
        return { isLogged: false, cookie };
      }
    } else return { isLogged: false, cookie };
  }
};
